import { useFormik } from "formik";
import React, { useState } from "react";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import CustomModal from "../../../../components/common/Modal";
import CustomTable from "../../../../components/common/CustomTable";
import { useToggleState } from "../../../../Hooks/useToggleState";
import { BASE_URL_IMAGE } from "../../../../Api/client";
import CustomFileUpload from "../../../../components/common/CustomFileUpload/CustomFileUpload";
import { useDispatch } from "react-redux";
import {
   addSingleCustomerChildAsync,
   fetchSingleCustomerMasterAsync,
   updateSingleCustomerChildAsync,
} from "../../../../redux/features/customerMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import validation from "../../../../helpers/validation";
import { BsPencilSquare } from "react-icons/bs";
import { MAX_DATE } from "../../../../Hooks/dateValidationRules";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";

const AgreementDocument = ({ agreementDocumentList }) => {
   const params = useParams();
   const dispatch = useDispatch();

   const [action, setAction] = useState("");
   const [initialState, setInitialState] = useState({
      id: "",
      document: null,
      startDate: "",
      endDate: "",
   });
   const [isChecked, setIsChecked] = useState({}); // State to manage toggle

   const [isModalVisible, handleShowModal, handleCloseModal] = useToggleState();
   const [isImageModalVisible, handleShowImageModal, handleCloseImageModal] =
      useToggleState();
   const [imageUrl, setImageUrl] = useState(null);

   const toggleSwitch = () => {
      // Toggle the state
   };

   //Handle Edit Button
   const handleEditButton = (item) => {
      setAction("edit");
      handleShowModal();
      console.log({ item });

      setValues({
         id: item.id,
         startDate: item?.start_date,
         endDate: item?.end_date,
         document: item?.agreement_document,
      });
   };

   const formik = useFormik({
      initialValues: initialState,
      validationSchema: Yup.object().shape({
         document: validation.file("Agreement Details"),
         startDate: Yup.date()
            .required("Start Date is required")
            .max(MAX_DATE, "The date cannot be later than December 31, 2999"),
         endDate: Yup.date()
            .required("End Date is required")
            .max(MAX_DATE, "The date cannot be later than December 31, 2999"),
      }),
      onSubmit:
         action === "add" ? handleAgreementDocumentAdd : handleAgreementDocumentUpdate,
   });

   const {
      touched,
      errors,
      values,
      getFieldProps,
      handleSubmit,
      resetForm,
      setFieldValue,
      setValues,
   } = formik;

   const columns = [
      {
         name: "Document",
         selector: (row) => (
            <div
               style={{ textDecoration: "underline", cursor: "pointer" }}
               onClick={() => {
                  setImageUrl(`${BASE_URL_IMAGE}${row.agreement_document}`);
                  handleShowImageModal();
               }}
            >
               {row.agreement_document}
            </div>
         ),
         sortable: true,
      },
      {
         name: "Start date",
         sortable: true,
         selector: (row) => {
            return row.start_date ?? "--";
         },
      },
      {
         name: "End date",
         sortable: true,
         selector: (row) => row.end_date ?? "--",
      },
      {
         name: "Action",
         selector: (row) => {
            return (
               <button className="btn mx-2" onClick={() => handleEditButton(row)}>
                  <BsPencilSquare
                     className="text-primary"
                     style={{ height: "1.5rem", width: "1.5rem" }}
                  />
               </button>
            );
         },
         width: "6rem",
      },
   ];

   const data = agreementDocumentList?.map?.((item) => ({
      ...item,
      action: (
         <div className="d-flex align-items-center">
            <button
               className="btn"
               onClick={() => {
                  setAction("edit");
                  setValues({ id: item?.id, document: null });
                  handleShowModal();
               }}
            >
               <BsPencilSquare
                  className="text-primary"
                  style={{ height: "1.5rem", width: "1.5rem" }}
               />
            </button>
            <CustomToggleSwitch
               checked={isChecked}
               onChange={toggleSwitch}
               id="csutomer6"
            />
         </div>
      ),
   }));

   function handleAgreementDocumentUpdate(formdata) {
      const newData = new FormData();

      newData.append("customer_master_id", params?.id);
      newData.append("document_id", formdata?.id);
      // newData.append("agreement_document[]", formdata?.document);
      newData.append("_method", "PATCH");
      newData.append("model_id", 6);
      newData.append("action_id", 2);

      if (typeof formdata?.agreementDocument === "object") {
         newData.append("agreement_document[]", formdata?.document);
      }
      newData.append("start_date[]", [formdata?.startDate]);
      newData.append("end_date[]", [formdata?.endDate]);
     

      dispatch(backdropLoadingAction(true));

      dispatch(
         updateSingleCustomerChildAsync({
            data: newData,
            err: () => {
               toast.error("Something went wrong !");
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               toast.success("Record updated successfully !");
               handleCloseModal();
               dispatch(
                  fetchSingleCustomerMasterAsync({
                     id: params?.id,
                     err: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                     done: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                  })
               );
            },
         })
      );
   }

   function handleAgreementDocumentAdd(formdata) {
      const newData = new FormData();

      newData.append("customer_master_id", params?.id);
      newData.append("agreement_document[]", formdata?.document);
      newData.append("start_date", formdata.startDate);
      newData.append("end_date", formdata.endDate);
      newData.append("model_id", 6);
      newData.append("action_id", 1);

      dispatch(backdropLoadingAction(true));

      dispatch(
         addSingleCustomerChildAsync({
            data: newData,
            err: () => {
               toast.error("Something went wrong !");
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               toast.success("Record added successfully !");
               handleCloseModal();
               dispatch(
                  fetchSingleCustomerMasterAsync({
                     id: params?.id,
                     err: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                     done: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                  })
               );
            },
         })
      );
   }

   return (
      <>
         <CustomModal
            showModal={isImageModalVisible}
            handleCloseModal={handleCloseImageModal}
            modalSize="modal-xl"
            title="Agreement document"
            hideFooter
            child={
               <div>
                  {/* <img src={imageUrl} style={{ width: "100%", height: "100%" }} /> */}
                  <object
                     data={imageUrl}
                     style={{ width: "100%", height: "70vh" }}
                  ></object>
               </div>
            }
         />
         <CustomModal
            showModal={isModalVisible}
            handleCloseModal={() => {
               resetForm();
               handleCloseModal();
            }}
            modalSize="modal-md"
            title="Agreement document"
            onSubmit={handleSubmit}
            child={
               <div>
                  <CustomFileUpload
                     label="Agreement Details"
                     {...getFieldProps(`document`)}
                     onChange={(event) =>
                        setFieldValue("document", event?.currentTarget?.files[0])
                     }
                     errors={touched?.document && errors?.document}
                     message={errors?.document}
                  />
                  <CustomDatePicker
                     require
                     label="Start date"
                     placeholder="Start date"
                     {...getFieldProps(`startDate`)}
                     errors={Boolean(touched.startDate) && Boolean(errors.startDate)}
                     message={errors.startDate}
                  />
                  <CustomDatePicker
                     require
                     label="End date"
                     placeholder="End date"
                     {...getFieldProps(`endDate`)}
                     errors={Boolean(touched.endDate) && Boolean(errors.endDate)}
                     message={errors.endDate}
                  />
               </div>
            }
         />
         <div className="d-flex w-100 mb-2 justify-content-between align-items-end">
            <label className="text-bold">Agreement Documents</label>
            <div className="">
               <button
                  type="button"
                  className="btn btn-primary float-right"
                  onClick={() => {
                     setAction("add");
                     setInitialState({
                        id: "",
                        document: null,
                     });
                     handleShowModal();
                  }}
               >
                  <i className="fas fa-plus"></i> Add More
               </button>
            </div>
         </div>
         <CustomTable columns={columns} data={data} />
      </>
   );
};

export default AgreementDocument;
